import { cva, type VariantProps } from "class-variance-authority";
import type { ButtonHTMLAttributes } from "react";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex h-11 items-center justify-center gap-2 rounded-xl px-4 text-sm font-semibold transition-colors outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-45",
  { variants: { variant: { default: "bg-slate-950 text-white hover:bg-blue-700", outline: "border border-slate-200 bg-white text-slate-800 hover:bg-slate-50", destructive: "bg-red-600 text-white hover:bg-red-700", ghost: "text-slate-700 hover:bg-slate-100", social: "h-12 border border-slate-200 bg-white text-slate-800 shadow-sm hover:border-slate-300 hover:bg-slate-50" }, size: { default: "h-11", icon: "size-11 p-0" } }, defaultVariants: { variant: "default", size: "default" } }
);

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {}

export function Button({ className, variant, size, ...props }: ButtonProps): React.JSX.Element {
  return <button className={cn(buttonVariants({ variant, size }), className)} {...props} />;
}
